import { useI18n } from "@/lib/i18n";

export default function TrustLogos() {
    const { t } = useI18n();

    return (
        <section
            id="erfahrung"
            data-testid="trust-logos-section"
            className="relative bg-white border-t border-b border-[#E2E8F0]"
        >
            <div className="max-w-4xl mx-auto px-5 lg:px-8 py-16 sm:py-20 text-center">
                <div className="text-[11px] sm:text-xs uppercase tracking-[0.28em] font-semibold text-[#10B981]">
                    Made for performance
                </div>
                <h2 className="mt-4 font-display font-semibold text-[#0F172A] tracking-tight text-balance text-[1.65rem] sm:text-3xl lg:text-4xl leading-[1.15]">
                    {t("sections.social_title")}
                </h2>
                <p className="mt-4 text-[#64748B] text-sm sm:text-base leading-relaxed max-w-2xl mx-auto">
                    {t("sections.social_sub")}
                </p>
            </div>
        </section>
    );
}
